"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = require("../styled-components");
const __1 = require("..");
const Wrapper = styled_components_1.styled.div `
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  width: 100%;
  align-content: start;
  border-top-right-radius: ${({ theme, topCornerRadiusRequired }) => topCornerRadiusRequired && theme.radius};
  border-top-left-radius: ${({ theme, topCornerRadiusRequired }) => topCornerRadiusRequired && theme.radius};
`;
const Inner = styled_components_1.styled.div `
  display: flex;
  flex-direction: column;
`;
const Button = styled_components_1.styled.button `
  color: inherit;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  background: transparent;
  border: none;
  cursor: pointer;
  ${({ indent }) => `padding: 2px 2px 2px ${Number(indent) + 2}px;`}
  margin-right: 8px;
  :disabled {
    opacity: 0.2;
    cursor: default;
  }
`;
const ExpandCollapse = ({ isExpanded, onClick, children, heading, indent = 0, disabled = false, noSeparator = false, buttonPosition, style, topCornerRadiusRequired, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const renderButton = (leftPad) => (react_1.default.createElement(Button, { type: "button", indent: leftPad, "data-testid": "expand-collapse-button", onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(), disabled: disabled }, !disabled && isExpanded ? (react_1.default.createElement(__1.ChevronUp, { title: t("button-Collapse") })) : (react_1.default.createElement(__1.ChevronDown, { title: t("button-Expand") }))));
    return (react_1.default.createElement(Wrapper, { className: disabled ? "" : "hover-highlight", topCornerRadiusRequired: topCornerRadiusRequired },
        heading && buttonPosition && buttonPosition === "right" ? (react_1.default.createElement(__1.Flex, { noWrap: true, align: "center", flex: "0 1 auto", style: style },
            heading,
            " ",
            renderButton(indent))) : heading ? (react_1.default.createElement(__1.Flex, { noWrap: true, align: "center", flex: "0 1 auto", style: style },
            renderButton(indent),
            heading)) : (react_1.default.createElement(__1.Flex, { justify: "center" }, renderButton(8))),
        noSeparator ? null : react_1.default.createElement(__1.Separator, { style: { margin: "10px 0 0 0" } }),
        react_1.default.createElement(Inner, null, !disabled && isExpanded && children)));
};
exports.default = ExpandCollapse;
//# sourceMappingURL=index.js.map